import { Pane } from 'evergreen-ui';

const EventBox = ({ ev, onClick, formatTime }) => {
  const start = ev.start;
  const end = ev.end || new Date(start.getTime() + 30 * 60000);
  const durationMinutes = Math.max(0, Math.round((end - start) / 60000));

  const threshold = 90;
  const isBrief = durationMinutes < threshold;

  const guestLabel = ev.data && (ev.data.guest_nome ? `${ev.data.guest_nome}${ev.data.guest_cognome ? ' ' + ev.data.guest_cognome : ''}` : (ev.data.guest_name ? ev.data.guest_name : null));
  const showGuest = durationMinutes >= 45;
  const author = ev.type === 'entry'
    ? `${ev.data.nome || ''} ${ev.data.cognome || ''}`.trim()
    : ((ev.data && (ev.data.user_nome || ev.data.user_cognome))
        ? `${ev.data.user_nome || ''} ${ev.data.user_cognome || ''}`.trim()
        : (ev.parent ? `${ev.parent.nome || ''} ${ev.parent.cognome || ''}`.trim() : ''));
        
  // Extract initials from first and last words of guest name
  const initialsMatch = guestLabel ? guestLabel.match(/\b\w/g) || [] : [];
  const initials = initialsMatch.length > 1
    ? (initialsMatch[0] + initialsMatch[initialsMatch.length - 1]).toUpperCase()
    : (initialsMatch[0] ? initialsMatch[0].toUpperCase() : '');
  
  const mainText = ev.type === 'entry' ? (ev.data.testo || '') : (ev.data.azione || '');
  const fullText = mainText;
  const truncated = (s, maxChars = 120) => {
    if (!s) return '';
    return s.length > maxChars ? s.slice(0, maxChars) + '...' : s;
  };

  const containerStyle = { display: 'flex', flexDirection: 'column', height: '100%', boxSizing: 'border-box' };
  const headerStyle = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 };
  const authorStyle = { fontSize: 12, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 };
  const timeStyle = { fontSize: 11, color: '#444', flex: '0 0 auto' };
  const bodyStyle = { marginTop: 4, display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0 };
  const textStyle = { fontSize: 13, color: '#222', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' };
  const guestStyle = { fontSize: 12, color: '#555', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };

  const bodyStyleBrief = { marginTop: 0, display: 'flex', flexDirection: 'column', gap: 0, minWidth: 0 };
  const textStyleBrief = { fontSize: 12, color: '#222', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
  const guestStyleBrief = { fontSize: 11, color: '#555', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' };

  return (
    <Pane onClick={onClick} style={containerStyle}>
      <div style={headerStyle}>
        {!isBrief && <div style={authorStyle}>{author}</div>}
        {!isBrief && <div style={timeStyle}>{formatTime(start)}{end ? ` - ${formatTime(end)}` : ''}</div>}
      </div>

      <div style={isBrief ? bodyStyleBrief : bodyStyle}>
        {showGuest && guestLabel && (
          <div style={isBrief ? guestStyleBrief : guestStyle}>{guestLabel}</div>
        )}
        <div style={isBrief ? textStyleBrief : textStyle} title={fullText || author}>
          {isBrief && initials ? `[${initials}] ` : ''}
          {truncated(mainText || author)}
        </div>
      </div>
    </Pane>
  );
};

export default EventBox;
